<script setup lang="ts">
import ThemeProvider from './providers/theme/ThemeProvider.vue'
import SidebarProvider from './providers/sidebar/SidebarProvider.vue'
import { ProviderKeys } from '@/app/providers/provider-keys'
import { provide } from 'vue'
import { AppRoutes } from './providers/app-router/app-routes'
import AxiosInstance from '@/app/providers/axios/axiosInstance.ts'
import AxiosInstanceWeb from '@/app/providers/axios/axiosInstanceWeb.ts'
import ToastContainer from '@/shared/toasts/ui/ToastContainer.vue'
import { ConfirmModal } from '@/shared/ui'

provide(ProviderKeys.AppRoutes, AppRoutes)
provide(ProviderKeys.AppAxios, AxiosInstance)
provide(ProviderKeys.AppAxiosWeb, AxiosInstanceWeb)
</script>

<template>
  <ThemeProvider>
    <SidebarProvider>
      <RouterView />
      <ToastContainer />
      <ConfirmModal />
    </SidebarProvider>
  </ThemeProvider>
</template>
